import axiosInstance from "./axiosInstance";

export const getAllCompanies = async () => {
  const res = await axiosInstance.get(`/company/list`)
  return res.data;
};

export const getCompanyDetails = async (id) => {
  const res = await axiosInstance.get(`/admin/company/details/${id}`);
  return res.data;
};

export const createCompany = async (formData) => {
  const res = await axiosInstance.post(`/admin/company/create`, formData);
  return res.data;
};

export const updateCompany = async (id, formData) => {
  const res = await axiosInstance.put(`/admin/company/update/${id}`, formData);
  return res.data;
};

export const deleteCompany = async (id) => {
  const res = await axiosInstance.delete(`/admin/company/delete/${id}`);
  return res.data;
};